export default __webpack_public_path__ + "static/media/book@2x.9cb491a5.png";